const admin_authorized_urls = [
    '/',
    '/add_users'
]

export {admin_authorized_urls}